<script>
import {main as navigation} from '../../navigation'

export default {
    props: {
        theme: {
            type: String,
            required: true
        },
        collapsed: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        openedKeys() {
            if (this.collapsed)
                return []

            return this.activeKeys
        },
        activeKeys() {
            let opened =  []
            let route = this.getRoute()
            _.forIn(this.navigation, function(value, key) {
                if (value.route === route) {
                    opened.push(value.route)
                }

                if (_.isObject(value.children)) {
                    _.forIn(value.children, function(v,k) {
                        if (v.route === route) {
                            opened.push(value.route)
                            opened.push(v.route)
                        }
                    })
                }
            })

            return opened
        }
    },
    data: () => ({
        navigation
    }),
    methods: {
        navigate(route) {
            let router = this.route(route)
            window.location.href = (router) ? '/'+router.uri : window.location.pathname
        },
        hasRole(menuItem) {
            // catch all, if no permission property is assigned, then we pass the truth test.
            if (menuItem instanceof Object && menuItem.hasOwnProperty('role') === false)
                return true

            // prepare data.
            let identifier = this.$laravel.active_module.module.identifier

            let roleInItem = menuItem.role[identifier]
            let roleInUser = this.$laravel.roles[identifier]

            // if not present in both of the items, then should be false.
            if (roleInItem === undefined || roleInUser === undefined)
                return false

            roleInUser = typeof roleInUser === "string" ? [roleInUser] : roleInUser

            // intersect.
            return Boolean(roleInItem.filter(x => roleInUser.includes(x)).length )
        }
    },
}
</script>
<template>
    <a-menu :theme="theme" mode="inline" class="menu" :defaultSelectedKeys="activeKeys" :defaultOpenKeys="openedKeys">
        <template v-for="(item, index) in navigation">
            <template v-if="item.hasOwnProperty('children')">
                <a-sub-menu :key="item.route" v-if="hasRole(item)">
                    <span slot="title"> <a-icon :type="item.icon" /> <span>{{ item.text }}</span></span>
                    <template v-for="child in item.children">
                        <a-menu-item v-if="hasRole(child)" :key="child.route">
                            <a :href="routeUri(child.route)"><span>{{ child.text }}</span></a>
                        </a-menu-item>
                    </template>
                </a-sub-menu>
            </template>
            <template v-else>
                <a-menu-item :key="item.route" v-if="hasRole(item)">
                    <a :href="routeUri(item.route)"><a-icon :type="item.icon" /> <span>{{ item.text }}</span></a>
                </a-menu-item>
            </template>
        </template>
    </a-menu>
</template>
